import React from 'react';
import Bg from '../../images/MainPage_Bg.png';

const Homepage = () => {
    return (
        <>
            <section className={`bg-no-repeat bg-cover bg-center w-full`} style={{ backgroundImage: `url(${Bg})` }}>
                <div className='flex items-center justify-center'>
                    <div className='flex flex-col py-20 justify-center max-w-[1920px]
                        sm:px-10 
                        md:px-12
                        lg:px-20
                        xl:px-[120px] '>
                        <h1 className=' font-semibold 
                        sm:text-4xl sm:pb-7
                        md:text-6xl md:pb-8
                        lg:text-7xl lg:pb-9
                        xl:text-8xl xl:pb-10'>ПК "СТРИЖ"</h1>
                        <p className='pb-24 
                        sm:text-base
                        md:text-base md:max-w-[60%] 
                        lg:max-w-[40%] lg:text-lg
                        xl:max-w-[40%] xl:text-lg'>Полетный контроллер <span className='font-bold uppercase text-[#304DB6]'>СТРИЖ</span> создан на основе отечественных микросхем. Этот контроллер обеспечивает высокую стабильность полета, точное позиционирование и эффективное управление беспилотным летательным аппаратом.</p>

                        <div className='flex items-center 
                        xl:gap-10
                        lg:gap-9 
                        md:gap-7 
                        sm:gap-6'>
                            <p className='text-[#304DB6] font-semibold 
                            xl:text-[42px]
                            lg:text-[36px] 
                            md:text-3xl 
                            sm:text-2xl'>30 400 ₽</p>
                            <button className='bg-[#304DB6] text-white rounded-md text-base max-h-10 hover:scale-110 transition duration-2000 transform'>
                            <p className='px-[50px] py-2'>Купить</p></button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Homepage; 
